export default "__VITE_ASSET__CQBfapo9__"